import { Link, SxProps, useTheme } from '@mui/material';
import React from 'react';

type LinkCallablePhoneProps = {
    phone: string;
    sxProps?: SxProps;
};
const LinkCallablePhone: React.FunctionComponent<LinkCallablePhoneProps> = function ({
    phone,
    sxProps,
}) {
    const { palette } = useTheme();

    return (
        <Link
            data-testid="link-callable-phone"
            sx={{
                textDecoration: 'none',
                color: palette.primary.dark,
                '&:hover': { color: palette.primary.main },
                ...sxProps,
            }}
            href={`tel:${phone.replaceAll(' ', '')}`}
        >
            {phone}
        </Link>
    );
};
export default LinkCallablePhone;
